import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7787a17d&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=7787a17d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7787a17d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7787a17d')) {
      api.createRecord('7787a17d', component.options)
    } else {
      api.reload('7787a17d', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=7787a17d&scoped=true&", function () {
      api.rerender('7787a17d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Header.vue"
export default component.exports